(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangementSearch', MusicalArrangementSearch);

    MusicalArrangementSearch.$inject = ['$resource'];

    function MusicalArrangementSearch($resource) {
        var resourceUrl =  'api/_search/musical-arrangements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
